module.exports = __webpack_public_path__ + "img/BarbaraOrvos.2c061d7.jpg";